import type {
  BffSystemPackageVersionResourceReadV2Api,
  SystemPackageVersionResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { SystemPackageVersionResource } from '../../models/systemPackageVersion.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapBffSystemPackagesVersionById(
  response: BffSystemPackageVersionResourceReadV2Api,
): SystemPackageVersionResource {
  return {
    artifacts: response.artifacts,
    compatibleOsVersionIds: response.compatibleOsVersionIds,
    creationDate: toIsoStringIfDate(response.creationDate),
    id: response.id,
    longDescription: response.longDescription,
    publisherId: response.publisherId,
    shortDescription: response.shortDescription,
    status: response.status,
    systemPackageId: response.systemPackageId,
    templates: response.templates,
    versionNumber: response.versionNumber,
    compatibleOsVersions: response.compatibleOsVersions,
    downloadRules: response.downloadPolicies,
  };
}

export function mapSystemPackagesVersionById(
  response: SystemPackageVersionResourceReadV2Api,
): SystemPackageVersionResource {
  return {
    artifacts: response.artifacts,
    compatibleOsVersionIds: response.compatibleOsVersionIds,
    creationDate: toIsoStringIfDate(response.creationDate),
    id: response.id,
    longDescription: response.longDescription,
    publisherId: response.publisherId,
    shortDescription: response.shortDescription,
    status: response.status,
    systemPackageId: response.systemPackageId,
    templates: response.templates,
    versionNumber: response.versionNumber,
    compatibleOsVersions: [],
    downloadRules: response.downloadPolicies,
  };
}
